import React from "react";
import { Helmet } from "react-helmet";

const WithdrawSEO = () => {
  return (

    <Helmet>
            {/* Page title optimized for the withdrawal page */}
            <title>Betpro Wallet Withdrawal - Fast & Secure Withdrawals</title>

            <link rel="icon" href="https://betprowallet.net/favicon.ico" />

            {/* Canonical tag */}
            <link rel="canonical" href="https://betprowallet.net/withdraw" />

            {/* Meta description focusing on withdrawing funds from Betpro Wallet */}
            <meta name="description" content="Withdraw your winnings quickly and securely from your Betpro Wallet account. ⚽️ Fast, reliable, and hassle-free withdrawal process with multiple payout options. Start withdrawing at Betprowallet.net." />

            {/* Meta keywords for search engine optimization */}
            <meta name="keywords" content="Betpro Wallet withdrawal, fast withdrawals, secure withdrawals, withdraw winnings, Betpro Wallet payout options, online betting withdrawals, Betprowallet.net withdrawal" />

            {/* Meta author */}
            <meta name="author" content="Betpro Wallet" />

            {/* Open Graph meta tags for social media sharing */}
            <meta property="og:title" content="Betpro Wallet Withdrawal - Fast & Secure Withdrawals" />
            <meta property="og:description" content="Withdraw your winnings quickly and securely from Betpro Wallet. Choose from multiple payout options for a fast, secure, and hassle-free withdrawal experience at Betprowallet.net." />
            <meta property="og:url" content="https://betprowallet.net/withdraw" />
            <meta property="og:type" content="website" />
            <meta property="og:image" content="https://betprowallet.net/bpthumb1.jpg" />

            {/* Twitter Card for sharing on Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Betpro Wallet Withdrawal - Fast & Secure Withdrawals" />
            <meta name="twitter:description" content="Withdraw your winnings quickly and securely from Betpro Wallet. Fast, reliable, and multiple payout options available at Betprowallet.net." />
            <meta name="twitter:image" content="https://betprowallet.net/bpthumb1.jpg" />

            {/* Structured Data for SEO */}
            <script type="application/ld+json">
              {`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Betpro Wallet Withdrawal - Fast & Secure Withdrawals",
            "url": "https://betprowallet.net/withdraw",
            "description": "Withdraw your winnings securely from your Betpro Wallet account. Enjoy fast payouts with multiple options for a hassle-free experience.",
            "publisher": {
              "@type": "Organization",
              "name": "Betpro Wallet"
            }
          }
        `}
            </script>
          </Helmet>


  );
};

export default WithdrawSEO;
